var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{ref:"editor",attrs:{"value":_vm.content},on:{"on-change":_vm.handleChange}}),_c('button',{on:{"click":_vm.changeContent}},[_vm._v("修改编辑器内容")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }